import { Alert, Skeleton } from "@gravity-ui/uikit";
import { useAction, useAtom } from "@reatom/npm-react";
import { useEffect } from "react";

import { ProfileCard } from "../../components";
import { ApiKeyCard } from "./components/ApiKeyCard/ApiKeyCard";
import { NewApiKeyCard } from "./components/NewApiKeyCard/NewApiKeyCard";
import { useTranslations } from "./hooks";
import { maxApiKeys } from "./PoizonApiKeysWidget.constants";
import css from "./PoizonApiKeysWidget.module.scss";
import { getUserApiTokens } from "./store/fetchers/getUserApiKeys";

export const PoizonApiKeysWidget = () => {
  const translations = useTranslations();
  const [userTokens] = useAtom(getUserApiTokens.dataAtom);
  const [isLoading] = useAtom(getUserApiTokens.isLoadingAtom);

  const getTokens = useAction(getUserApiTokens);

  useEffect(() => {
    getTokens();
  }, [getTokens]);

  if (isLoading && !userTokens) return <Skeleton style={{ height: "200px" }} />;

  if (!userTokens) return <Alert theme="danger" title={translations.alert} />;

  const hasTokenSpace = userTokens.length < maxApiKeys;

  return (
    <ProfileCard title={translations.title}>
      <div className={css.grid}>
        {userTokens.map((apiKey, index) => {
          return <ApiKeyCard apiKey={apiKey} key={`apikeycard_${index}`} />;
        })}
        {hasTokenSpace && <NewApiKeyCard />}
      </div>
    </ProfileCard>
  );
};
